import { render } from "./stage-details.component.vue?vue&type=template&id=37a0ab75&scoped=true"
import script from "./stage-details.component.vue?vue&type=script&lang=js"
export * from "./stage-details.component.vue?vue&type=script&lang=js"

import "./stage-details.component.vue?vue&type=style&index=0&id=37a0ab75&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a0ab75"]])

export default __exports__